import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const MobileNavigation = () => {
  const location = useLocation();

  const navigationItems = [
    {
      label: 'Trip Settings',
      path: '/trip-settings',
      icon: 'Settings'
    },
    {
      label: 'Inventory',
      path: '/inventory-management',
      icon: 'Package'
    },
    {
      label: 'Meal Planning',
      path: '/meal-planning',
      icon: 'Calendar'
    }
  ];

  const isAuthPage = location?.pathname === '/login' || location?.pathname === '/register';

  if (isAuthPage) {
    return null;
  }

  return (
    <nav className="mobile-nav">
      <div className="mobile-nav-content">
        {navigationItems?.map((item) => (
          <Link
            key={item?.path}
            to={item?.path}
            className={`mobile-nav-link ${location?.pathname === item?.path ? 'active' : ''}`}
          >
            <Icon 
              name={item?.icon} 
              size={24}
              color={location?.pathname === item?.path ? 'var(--color-primary)' : 'currentColor'}
            />
            <span className="mobile-nav-label">{item?.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default MobileNavigation;